import React from "react";
import { makeStyles } from "@material-ui/core";
import OrgLogo from "./OrgLogo";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  logoContainer: {
    width: "64px",
    height: "64px",
    minHeight: "64px",
    minWidth: "64px",
    paddingRight: "12px"
  },
  orgName: {
    textTransform: "uppercase"
  },
  info: {
    paddingLeft: "12px",
    "& div": {
      fontSize: 10,
      lineHeight: "16px",
      paddingBottom: theme.spacing()
    }
  }
}));

const CardOrganization = (props) => {
  const {logo, orgName} = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.logoContainer}>
        <OrgLogo imgId={logo} />
      </div>
      <div className={classes.info}>
        {orgName && <div className={classes.orgName}>{orgName}</div>}
      </div>
    </div>
  );
}

export default CardOrganization;
